// eslint-disable-next-line @typescript-eslint/no-explicit-any -- expected usage
export const hasDefinedProps = <T extends Partial<Record<K, any>>, K extends PropertyKey>(
  obj: T,
  ...keys: K[]
): obj is T & { [P in K]-?: Exclude<T[P], undefined> } => {
  return keys.every((k) => obj[k] !== undefined);
};
